export const NAVIGATION_ITEMS = Object.freeze([
  Object.freeze({ id: "home", label: "Home", href: "/", editable: true }),
  Object.freeze({ id: "terms", label: "Terms of Service", href: "/terms/", editable: true }),
  Object.freeze({ id: "contact", label: "Contact Staff", href: "/contact/", editable: true }),
]);

export const NAVIGATION_CONFIG = Object.freeze({
  items: NAVIGATION_ITEMS,
  accountLabel: "Already enlisted?",
  loginLabel: "Log in",
  loginHref: "/login/",
  loginEnabled: false,
});
